import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchWarehouse(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let pageno = !value.value
    ? 1
    : value.value.pageno === undefined
    ? 1
    : value.value.pageno;
  let search = (value.value && value.value.search) || "";
  let filter = (value.value && value.value.filter) || "";

  let filterParam = "";
  if (filter) {
    filterParam = `&warehouseType=${filter}`;
  }
  try {
    const res = yield fetch(
      `${appConfig.ip}/warehouse?orgId=${id}&isActive=true&limit=10&search=${search}&page=${pageno}${filterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      console.log("#############resJSON", resJSON);
      yield put({
        type: actionTypes.FETCH_WAREHOUSE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_WAREHOUSE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchWarehouseMaterials() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/warehouseMaterial`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_WAREHOUSEMATERIALS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WAREHOUSEMATERIALS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addWarehouse(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  const data = {
    name: value.value.name,
    addr1: value.value.addr1,
    capacity: value.value.capacity,
    desc: value.value.desc,
    unit: value.value.unit,
    materials: (value.value && value.value.materials) || [],
    perUnitPrice: value.value.perUnitPrice,
    orgId: user.orgId,
    user: user.id,
    currency: user.curncyCode,
    geo: value.value.geo,
    sellableUnit: value.value.sellableUnit,
    warehouseType: value.value.warehouseType,
    geoAddr: value.value.geoAddr,
  };

  let imageData = {
    file: value.value && value.value.image,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/warehouse`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.ADD_WAREHOUSE_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: "ADD_WAREHOUSEIMAGE_INIT_ACTION",
        value: imageData,
        id: resJSON.id,
      });
      if (resJSON.error === true) {
        yield toast.error(resJSON.err.message, {
          autoClose: 3000,
          className:"toastClass"
        });
      } else {
        yield toast.success("Warehouse added successfully", {
          autoClose: 3000,
          className:"toastClass"
        });
      }

      yield put({
        type: actionTypes.FETCH_WAREHOUSE_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_WAREHOUSE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editWarehouse(value) {
  let id = value.id;
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  const data = {
    name: value.value.name,
    orgId: user.orgId,
    user: user.id,
    addr1: value.value.addr1,
    capacity: value.value.capacity,
    image: value.value.image,
    unit: value.value.unit,
    desc: value.value.desc,
    materials:
      value.value && value.value.materials
        ? typeof value.value.materials[0] === "object"
          ? value.value.materials.map((data) => data.id)
          : value.value.materials
        : [],
    perUnitPrice: value.value.perUnitPrice,
    geo: value.value.geo,
    sellableUnit: value.value.sellableUnit,
    warehouseType: value.value.warehouseType,
    currency: user.curncyCode,
    geoAddr: value.value.geoAddr,
  };

  let imageData = {
    file: value.value && value.value.image,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/warehouse/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.EDIT_WAREHOUSEIMAGE_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Warehouse updated successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      console.log("!!!!!!!!!",typeof value.value.image)
      if (typeof value.value.image === "object") {
        yield put({
          type: "ADD_WAREHOUSEIMAGE_INIT_ACTION",
          value: imageData,
          id: resJSON.id,
        });
      } else {
        if (resJSON.error === true) {
          yield toast.error(resJSON.err.message, {
            autoClose: 3000,
            className:"toastClass"
          });
        } else {
          yield put({
            type: actionTypes.FETCH_WAREHOUSE_INIT_ACTION,
          });
        }
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_WAREHOUSEIMAGE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addWarehouseImg(value) {
  try {
    const data = new FormData();

    data.append(value.id, value.value.file, value.value.file.name);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/warehouse/image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      let resJSON = yield res.json();
      console.log("*****resJSON******", resJSON);
      yield put({
        type: actionTypes.ADD_WAREHOUSEIMAGE_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_WAREHOUSE_INIT_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_WAREHOUSEIMAGE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchUnit() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/unit?unitType=warehouse`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_UNIT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_UNIT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* WarehouseActionWatcher() {
  yield takeEvery(actionTypes.FETCH_WAREHOUSE_INIT_ACTION, fetchWarehouse);
  yield takeEvery(
    actionTypes.FETCH_WAREHOUSEMATERIALS_INIT_ACTION,
    fetchWarehouseMaterials
  );
  yield takeEvery(actionTypes.ADD_WAREHOUSE_INIT_ACTION, addWarehouse);
  yield takeEvery(actionTypes.ADD_WAREHOUSEIMAGE_INIT_ACTION, addWarehouseImg);
  yield takeEvery(actionTypes.EDIT_WAREHOUSEIMAGE_INIT_ACTION, editWarehouse);
  yield takeEvery(actionTypes.FETCH_UNIT_INIT_ACTION, fetchUnit);
}
